import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

import { routes } from './app.routes';
import { VivobeneTheme } from '../VivobeneTheme';
import { provideHttpClient } from '@angular/common/http';
import { appInitializerFactory } from './app-initializer-factory';
import { AppConfigService } from './core/services/app-config.service';
import { MessageService } from 'primeng/api';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, 
      withInMemoryScrolling({
        scrollPositionRestoration: 'top'
      })
    ),
    provideAnimationsAsync(),
    provideHttpClient() ,
    providePrimeNG({
      theme: {
        preset: VivobeneTheme,
        options: {
          darkModeSelector: false
        }
      },
      ripple: true
    }),
    provideAppInitializer(appInitializerFactory),
    MessageService
  ],
};

